import ProgramasSaudeIndex from "@/pages/programas-saude/index.vue";
import ProgramasSaudeList from "@/pages/programas-saude/list.vue";
import ProgramasSaudeTerm from "@/pages/programas-saude/term.vue";
import ProgramasSaudeCreate from "@/pages/programas-saude/create.vue";
import ProgramasSaudeRevision from "@/pages/programas-saude/revisao.vue";
import ProgramasSaudeUpload from "@/pages/programas-saude/upload-file.vue";
import ProgramasSaudeDetail from "@/pages/programas-saude/detail.vue";

const routes: Route[] = [
  {
    path: "/programas-saude",
    name: "programas-saude",
    component: ProgramasSaudeIndex,
    children: [
      {
        path: "",
        component: ProgramasSaudeList,
        meta: {
          backTo: "/",
          validPath: ["/programas-saude"]
        },
        name: "programas-saude-list"
      },
      {
        path: "criar",
        name: "programas-saude-create",
        component: ProgramasSaudeCreate,
        meta: {
          backTo: "/programas-saude",
          validPath: ["/programas-saude"]
        }
      },
      {
        path: "criar/termo",
        name: "programas-saude-term",
        component: ProgramasSaudeTerm,
        meta: {
          backTo: "/programas-saude",
          validPath: ["/programas-saude"]
        }
      },
      {
        path: "criar/revisao",
        name: "programas-saude-revision",
        component: ProgramasSaudeRevision,
        meta: {
          backTo: "/programas-saude/criar/termo",
          validPath: ["/programas-saude"]
        }
      },
      {
        path: "criar/upload",
        name: "programas-saude-upload",
        component: ProgramasSaudeUpload,
        meta: {
          backTo: "/programas-saude/criar/revisao",
          validPath: ["/programas-saude"]
        }
      },
      {
        path: "detalhe/:protocol",
        name: "programas-saude-detail",
        component: ProgramasSaudeDetail,
        meta: {
          backTo: "/programas-saude",
          validPath: ["/programas-saude"]
        }
      }
    ]
  }
];

export default routes;
